<div class="d-flex align-items-baseline gap-space-4 flex-wrap">
    @if (hasHeader) {
        <p
            class="typography-title-large">
            <ng-content></ng-content>
        </p>
    }

    <lib-button
        [kind]="ButtonKind.Link"
        [size]="ButtonSize.XLarge"
        [suffixIcon]="Icon.Common.CaretDown"
        [qaTag]="qaTag ? qaTag + '_Button' : '$$DateSelector_Button'"
        mbsc-datepicker
        [min]="minDateJS"
        [max]="maxDateJS"
        [scrollLock]="true"
        [attr.placeholder]="placeholderText"
        [monthNames]="localeInfo.MonthNames"
        [monthNamesShort]="localeInfo.AbbreviatedMonthNames"
        [dayNamesShort]="localeInfo.AbbreviatedDayNames"
        [dayNamesMin]="localeInfo.AbbreviatedDayNames"
        [dateFormat]="dateFormatPattern | uppercase"
        [firstDay]="firstDayOfWeek"
        themeVariant="light"
        [rtl]="localeInfo.RightToLeft"
        [focusOnClose]="false"
        [touchUi]="isMobile"
        (onChange)="DateChangeEvent($event)"
        (onInit)="ComponentInitialized($event)"
        (onOpen)="PopupOpened($event); SetDate()"
        (change)="$event.stopPropagation()">
        <ng-container label>{{ viewControl.value }}</ng-container>
    </lib-button>
</div>
